import * as elvish from '@didi/elvish-lib-javascript'
import * as XLSX from 'xlsx'
import { GtrTabCommunication } from '@didi/gattaran-common-micro-utils'
import { LANG_MAP } from '@/plugins/pebble-ui'
import { env } from '@/utils'
import { gtrAuth, gtrAuths } from '@/utils/gtr-auth'
import { request, initRequestParams, CancelToken } from '@/plugins/plugin-request'
import { Omega } from '@/plugins/plugin-init-omega'
import { FORMILY_LANG_MAP } from '../formily/index'
import { IS_SIM, IS_DEV, IS_PRE } from '@/config/constants'
import { getAuthParams } from '@/plugins/plugin-sso-login'
import Iframe from './iframe.vue'
import Lowcode from './lowcode.vue'
import Weblink from './weblink.vue'
// 开发环境低代码获取SIM环境的配置配置前缀
const DEV_APPKEY_PREFIX = 'sim060'
/**
 * 请求适配器函数，用于处理低码请求配置
 * @param {Object} config - 请求配置对象
 * @param {string} config.method - 请求方法
 * @param {string} config.uri - 请求URI
 * @param {boolean} config.isCors - 是否跨域请求
 * @param {Object} config.params - 请求参数
 * @param {Object} config.headers - 请求头
 * @returns {Promise} 返回请求响应的Promise
 */
const fetchAdapter = config => {
  const { method, uri, isCors, params, headers, ...otherConfig } = config
  const timeout = +otherConfig?.timeout || 0
  return request[method.toLocaleLowerCase()]({
    url: params.api ? params.api : uri,
    params,
    headers,
    config: {
      ...otherConfig,
      // 设置最小超时时间为10秒，0表示不设置超时
      timeout: timeout > 0 && timeout < 10000 ? 10000 : timeout,
    },
    ...otherConfig,
  }).then(res => ({
    data: res,
  }))
}

/** 低码接入的应用key列表 */
// 注意接入规范，确定应用设置的应用访问路径为 lowcode_ 开头的！！
export const LOWCODE_KEYS = [
  '3137cc62f432a335574b51626c690bca', // GTR 嵌入站测试 https://fuxi.intra.didiglobal.com/fuxi/app-space/1000135/workshop
  '31e43154f620787a162df31b5df7f686', // GTR-D新业务 https://fuxi.intra.didiglobal.com/fuxi/app-space/1000137/workshop
  '4c75ba24c2b9a5e70c002d752d54419c', // GTR-销售任务系统 https://fuxi.intra.didiglobal.com/fuxi/app-space/1000133/workshop
  '28a6e19f2435e85637f2189d27f210eb', // GTR-D供需 https://fuxi.intra.didiglobal.com/fuxi/app-space/1000141/workshop
  '4b52e41b889d00a18e11967987173d7b', // GTR-广告代运营系统 https://fuxi.intra.didiglobal.com/fuxi/app-space/1000147/workshop
  '9b54eb2a66cf0270a27870aa84a1a491', // GTR-油站CRM中台 https://fuxi.intra.didiglobal.com/fuxi/app-space/1000145/workshop
  '39197de90bed36d09a5154c1f991ad4c', // GTR-C用户营销 https://fuxi.intra.didiglobal.com/fuxi/app-space/1000153/workshop   /user-marketing
  '849c4a8c82aeb7d27c6a065338d260e2', // GTR-控制台 https://fuxi.intra.didiglobal.com/fuxi/app-space/1000187/workshop
  '685977219393edee396d020ee4ea3b53', // GTR-B商户营销 https://fuxi.intra.didiglobal.com/fuxi/app-space/1000215/workshop
  '1bc4268fed2526b2b65744d8c99ebea5', // GTR-客户管理系统 https://fuxi.intra.didiglobal.com/fuxi/app-space/1000181/workshop
  'fce742f8a87389c0eade84599a70fe76', // GTR-OpenAPI开放后台 https://fuxi.intra.didiglobal.com/fuxi/app-space/1000241/page-manage
  '3c06f2257de13d187dc6d88bb31dc5c6', // GTR-B营销 https://fuxi.intra.didiglobal.com/fuxi/app-space/1000249/workshop
  '5eaa9fa0755c9298ef80f812f487840a', // GTR-D营销 https://fuxi.intra.didiglobal.com/fuxi/app-space/1000255/workshop
  '2e07f94ab7cfc532305dcf2cd79ebb4d', // GTR-加特兰商家定价 https://fuxi.intra.didiglobal.com/fuxi/app-space/1000251/page-manage
  '888b1d1690e3c77754b970b17f435be2', // GTR-D骑手管理 https://fuxi.intra.didiglobal.com/fuxi/app-space/1000263/workshop
  '009f86345f2039b6167de2dc9acb43be', // GTR-D外包管理 https://fuxi.intra.didiglobal.com/fuxi/app-space/1000269/workshop
  '02815f59d328fb00bd41dfc4c4cba781', // GTR-C\D定价管理 https://fuxi.intra.didiglobal.com/fuxi/app-space/1000271/workshop
  '7a7b0be63a75fb2ebe962fcfac410138', // GTR-antiFraud https://fuxi.intra.didiglobal.com/fuxi/app-space/1000307/page-manage viktorli@didiglobal.com
  '8915ce8511ebc7e112676af902e3a142', // GTR-商家生态 https://fuxi.intra.didiglobal.com/fuxi/app-space/1000317/workshop
  '699d0ecf20c028cb320acdb18cdb1eca', // GTR-搜索工具 https://fuxi.intra.didiglobal.com/fuxi/app-space/1000335/workshop
  '382454837e5ed92df514a6119d15f1d3', // GTR_MerchantGuard https://fuxi.intra.didiglobal.com/fuxi/app-space/1000333/workshop baoleilei@didiglobal.com
  '8a85ba262c29c3a43622885149893335', // GTR-saas-operation-system https://fuxi.intra.didiglobal.com/fuxi/app-space/1000357/workshop
  '4d131d39fa567f99786979f4da1b157b', // GTR-治理中台 https://fuxi.intra.didiglobal.com/fuxi/app-space/1000359/workshop
]
export const BASE_SIM_FLAG = 'sim060'
export const APPKEY_PREFIX = (() => {
  let prefix
  if (IS_DEV) {
    prefix = DEV_APPKEY_PREFIX
  } else if (IS_SIM) {
    prefix = window.location.host.replace(/.*(sim\d+).+/, (match, $1) => {
      return $1
    })
  } else if (IS_PRE) {
    prefix = 'pre'
  } else {
    prefix = 'prod'
  }
  return `${prefix}_app_`
})()
export const keyToAppKey = key => {
  return APPKEY_PREFIX + key
}
export const keyToBaseSimAppKey = key => {
  return `sim060_app_${key}`
}
export const APP_KEYS = LOWCODE_KEYS.map(key => {
  return keyToAppKey(key)
})
// 基准环境appkeys
export const BASE_SIM_APP_KEYS = LOWCODE_KEYS.map(key => {
  return keyToBaseSimAppKey(key)
})
/** fuxisdk 需要的环境变量配置 */
export const FUXI_ENV = (() => {
  if (IS_DEV || IS_SIM) {
    return 'sim'
  } else if (IS_PRE) {
    return 'pre'
  } else {
    return 'prod'
  }
})()
/** 低码支持的组件类型 */
export const fuxiComponents = {
  1: Weblink,
  2: Iframe,
  3: Lowcode,
}
export const initFormilyI18n = curLan => {
  // 设置语言
  if (window.DidiPebbleFormilyMaterials) {
    window.DidiPebbleFormilyMaterials?.setValidateLanguage(curLan || env.get('userInfo').locale)
    window.DidiPebbleFormilyMaterials?.registerValidateLocale({
      [curLan]: { ...FORMILY_LANG_MAP[curLan] },
    })
  }
}
export const initPebbleI18n = curLan => {
  if (window.ELEMENT) {
    window.ELEMENT.locale(LANG_MAP[curLan])
  }
}
/** 注入到低码的参数 */
export const getLowcodeConfig = () => {
  const { locale, country, username } = env.get('userInfo')
  const userAuthCountry = env.get('userAuthCountry')
  const { ticket } = getAuthParams()
  return {
    locale,
    scope: {
      CONSTANT: {
        locale,
        country,
        username,
        userAuthCountry,
        ticket,
      },
      UTILS: {
        gtrAuth,
        gtrAuths,
        XLSX,
        Omega,
        elvish,
        gtrRequest: request,
        getGtrFetchParams: initRequestParams(),
        cancelToken: CancelToken, // 取消请求方法
        GtrTabCommunication,
      },
    },
    requestHandlersMap: {
      fetch: fetchAdapter,
    },
  }
}
